import { design } from '@/config/enums'

export default {
  getTagVariant: state => {
    return state.propertyType === 'wohnung' ? 'wohnung' : state.tagVariant
  },
  hausankerDesign: state => state.design === design.HAUSANKER,
  slide: state => state.slides[state.currentSlide],
  slideByName: state => slideName => {
    return state.slides.find(slide => slide.slideName === slideName)
  },
  numOfSlides: state => state.slides.length,
  nextEnabled: state => {
    return state.slides[state.currentSlide].nextEnabled
  },
  sendData: state => {
    return state.slides[state.currentSlide].sendData
  },
  validateOnNext: state => {
    return state.slides[state.currentSlide].validationOnNext
  },
  nextButtonImg: state => {
    return state.slides[state.currentSlide].nextButtonImg
  },
  nextButtonLink: state => {
    return state.slides[state.currentSlide].nextButtonLink
  },
  nextButtonText: state => {
    return state.slides[state.currentSlide].nextButtonText
  },
  nextButtonLong: state => {
    return state.slides[state.currentSlide].nextButtonMode === 'long'
  },
  showNextButton: state => {
    if (state.slides[state.currentSlide].nextButton === false) {
      return false
    } else {
      return true
    }
  },
  showBackButton: state => {
    if (state.slides[state.currentSlide].backButton === false) {
      return false
    } else {
      return true
    }
  }
}
